// Shared bounds + input sanitiser for the vehicle "Year" filter.
// Keeps the filter in step with the vehicle listing zod rule (validation.ts:
// year must be 1900 or later and no later than next year).

export const MIN_FILTER_YEAR = 1900
export const MAX_FILTER_YEAR = new Date().getFullYear() + 1

/**
 * Sanitises a raw year-filter input string so a negative value can never be
 * entered (the reported bug: the number spinner let the value fall to -1).
 *
 * - empty stays empty (so the field can be cleared)
 * - a leading minus / any non-digit is stripped, so -1 becomes 1
 * - values above the max year are clamped
 * - short in-progress values (e.g. "19") are left alone so typing isn't fought
 */
export function sanitizeYearFilterInput(raw: string): string {
  const digits = raw.replace(/[^0-9]/g, '')
  if (digits === '') return ''
  const n = Number(digits)
  if (n > MAX_FILTER_YEAR) return String(MAX_FILTER_YEAR)
  return digits
}
